import { create } from 'zustand';
import axiosClient from '../services/api';

const useRevenueStore = create((set, get) => ({
  revenue: null,
  withdrawals: [],
  isLoading: false,
  error: null,

  fetchRevenue: async () => {
    set({ isLoading: true, error: null });
    try {
      const res = await axiosClient.get('/revenue/instructor');
      set({ revenue: res.data.data, isLoading: false });
    } catch (error) {
      set({ error: error.response?.data?.error || 'Failed to fetch revenue', isLoading: false });
    }
  },

  requestWithdrawal: async (amount) => {
    const res = await axiosClient.post('/revenue/withdraw', { amount });
    return res.data;
  }
}));

export default useRevenueStore;

// import { create } from 'zustand';
// import axiosClient from '../services/api';

// const useRevenueStore = create((set, get) => ({
//   revenueOverview: null,
//   revenueHistory: [],
//   withdrawalSchedule: null,
//   revenueForecast: null,
//   isLoading: false,
//   error: null,

//   fetchRevenueOverview: async () => {
//     set({ isLoading: true, error: null });
//     try {
//       const response = await axiosClient.get('/payments/revenue/overview');
//       set({ revenueOverview: response.data.data, isLoading: false });
//     } catch (error) {
//       set({ error: error.response?.data?.error || 'Failed to fetch revenue overview', isLoading: false });
//     }
//   },

//   fetchRevenueHistory: async (startDate, endDate) => {
//     set({ isLoading: true, error: null });
//     try {
//       const response = await axiosClient.get('/payments/revenue/history', {
//         params: {
//           startDate: startDate.toISOString(),
//           endDate: endDate.toISOString()
//         }
//       });
//       set({ revenueHistory: response.data.data, isLoading: false });
//     } catch (error) {
//       set({ error: error.response?.data?.error || 'Failed to fetch revenue history', isLoading: false });
//     }
//   },

//   requestWithdrawal: async (withdrawalData) => {
//     set({ isLoading: true, error: null });
//     try {
//       const response = await axiosClient.post('/payments/revenue/withdraw', withdrawalData);
//       set({ isLoading: false });
//       return response.data;
//     } catch (error) {
//       set({ error: error.response?.data?.error || 'Failed to request withdrawal', isLoading: false });
//       throw error;
//     }
//   }, 

//   scheduleWithdrawals: async (scheduleData) => {
//     set({ isLoading: true, error: null });
//     try {
//       const response = await axiosClient.post('/payments/schedule', scheduleData);
//       set({ isLoading: false });
//       return response.data;
//     } catch (error) {
//       set({ error: error.response?.data?.error || 'Failed to schedule withdrawals', isLoading: false });
//       throw error;
//     }
//   },

//   getWithdrawalSchedule: async () => {
//     set({ isLoading: true, error: null });
//     try {
//       const response = await axiosClient.get('/payments/schedule');
//       set({ withdrawalSchedule: response.data.data, isLoading: false });
//     } catch (error) {
//       set({ error: error.response?.data?.error || 'Failed to fetch withdrawal schedule', isLoading: false });
//     }
//   },

//   cancelWithdrawalSchedule: async () => {
//     set({ isLoading: true, error: null });
//     try {
//       const response = await axiosClient.delete('/payments/schedule');
//       set({ withdrawalSchedule: response.data.data, isLoading: false });
//     } catch (error) {
//       set({ error: error.response?.data?.error || 'Failed to cancel withdrawal schedule', isLoading: false });
//     }
//   },

//   getRevenueForecast: async () => {
//     set({ isLoading: true, error: null });
//     try {
//       const response = await axiosClient.get('/payments/forecast');
//       set({ revenueForecast: response.data.data, isLoading: false });
//     } catch (error) {
//       set({ error: error.response?.data?.error || 'Failed to fetch revenue forecast', isLoading: false });
//     }
//   }
// }));

// export default useRevenueStore;